import { MEMBERS_SORT_COLUMN_LABELS } from "@components/table/members/members-table-constants";
/** Default workspace members sort by option */
export const DEFAULT_WORKSPACE_MEMBERS_SORT_BY = "user_ascending";

/** Default project/group members sort by option */
export const DEFAULT_MEMBERS_SORT_BY = "name_ascending";
export const DEFAULT_TEAM_MEMBERS_SORT_BY = "newest_first";

/** Available members sort field options */
export const MEMBERS_SORT_OPTIONS = {
  user: {
    field: "user",
    label: MEMBERS_SORT_COLUMN_LABELS.user
  },
  name: {
    field: "name",
    label: MEMBERS_SORT_COLUMN_LABELS.name
  },
  email: {
    field: "email",
    label: MEMBERS_SORT_COLUMN_LABELS.email
  },
  status: {
    field: "status",
    label: MEMBERS_SORT_COLUMN_LABELS.status
  },
  role: {
    field: "role",
    label: MEMBERS_SORT_COLUMN_LABELS.role
  },
  joinedDate: {
    field: "joinedDate",
    label: MEMBERS_SORT_COLUMN_LABELS.joinedDate
  },
  seats: {
    field: "seats",
    label: MEMBERS_SORT_COLUMN_LABELS.seats
  }
};

/** Map of the sort by options to the SortItem format */
export const MEMBERS_SORT_BY_MAP = {
  ["user_ascending"]: {
    field: "user",
    sort: "asc"
  },
  ["user_descending"]: {
    field: "user",
    sort: "desc"
  },
  ["name_ascending"]: {
    field: "name",
    sort: "asc"
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc"
  },
  ["email_ascending"]: {
    field: "email",
    sort: "asc"
  },
  ["email_descending"]: {
    field: "email",
    sort: "desc"
  },
  ["status_ascending"]: {
    field: "status",
    sort: "asc"
  },
  ["status_descending"]: {
    field: "status",
    sort: "desc"
  },
  ["role_ascending"]: {
    field: "role",
    sort: "asc"
  },
  ["role_descending"]: {
    field: "role",
    sort: "desc"
  },
  ["joinedDate_ascending"]: {
    field: "joinedDate",
    sort: "asc"
  },
  ["joinedDate_descending"]: {
    field: "joinedDate",
    sort: "desc"
  },
  ["seats_ascending"]: {
    field: "seats",
    sort: "asc"
  },
  ["seats_descending"]: {
    field: "seats",
    sort: "desc"
  }
};
/** Available team members sort field options */
export const TEAM_MEMBERS_SORT_OPTIONS = {
  joinedDate: {
    field: "joinedDate",
    label: MEMBERS_SORT_COLUMN_LABELS.joinedDate
  }
};

/** Map of team member sort options to SortItem format */
export const TEAM_MEMBERS_SORT_BY_MAP = {
  ["newest_first"]: {
    field: "joinedDate",
    sort: "desc"
  },
  ["oldest_first"]: {
    field: "joinedDate",
    sort: "asc"
  }
};